<template>
  <div
    class="optionSelect d-flex a-center"
    style="margin-bottom:-6px;font-size:0.875rem;"
  >
    <!-- <div class="main-text-color" style="margin-right:26px;">名称</div> -->

    <el-form
      :inline="true"
      class="demo-form-inline"
      label-position="right"
      :label-width="labelWidth / 16 + 'rem'"
    >
      <el-form-item
        :label="labelValue"
        style="font-size:0.875rem;"
        :class="[isRequired ? 'requireField' : '']"
      >
        <el-select
          v-model="value"
          :placeholder="placeholder"
          :disabled="isDisabled"
          @change="changeHandle"
          :multiple="isMultiple"
          :filterable="isFilterable"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "optionSelect",
  props: {
    options: {
      type: Array,
      required: true,
    },
    level: {
      type: String | Number,
      default: 0,
    },
    isMultiple: {
      type: Boolean | String,
      default: false,
    },
    isRequired: {
      type: Boolean | String,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    field: {
      type: String,
    },
    fieldName: String,
    placeholder: {
      type: String,
    },
    labelValue: {
      type: String,
      required: true,
    },
    defaultValue: {
      type: String | Number,
    }, // 这里对应的是id id和options匹配的话 选择框显示的是label值
    labelWidth: {
      default: "100",
    },
    isFilterable: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      value: "",
    };
  },
  watch: {
    defaultValue: {
      handler: function(newVal) {
        this.value = newVal;
      },
      deep: true,
    },
    value(newval) {
      // 说明没有被dialog包裹
      if (this.level == 0) {
        if (this.field) {
          this.$parent[this.field][this.fieldName] = newval;
        } else {
          this.$parent[this.fieldName] = newval;
        }
      } else {
        if (this.field) {
          this.$parent.$parent[this.field][this.fieldName] = newval;
        } else {
          // console.log(this.$parent.$parent.orderPerson)
          this.$parent.$parent[this.fieldName] = newval;
        }
      }
    },
  },
  methods: {
    changeHandle() {
      this.$emit("getSelectValue", this.value);
    },
  },
  mounted() {
    if (this.defaultValue || this.defaultValue == 0) {
      this.value = this.defaultValue;
    } else {
      this.value = "";
    }
  },
};
</script>

<style scoped lang="less">
.optionSelect /deep/ .el-select {
  width: 21.825rem !important;
  height: 46px !important;
}
.requireField {
  position: relative;
}
.requireField::after {
  content: "*";
  color: #de1e23;
  position: absolute;
  top: 43%;
  left: 20px;
  transform: translateY(-50%);
}
</style>
